import { AuthApi } from "api/auth";
import { PATH } from "constants/path";
import { ResponseCode } from "constants/response";
import { ModalTypeValue } from "enums/modalType";
import { handleResetData } from "helpers/handleResetData";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMobile } from "router";
import { selectToken, selectUsername } from "store/auth";
import { setOpenModal } from "store/master";

import { useAppDispatch, useAppSelector } from "./app-hook";

export const useVerify = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const username =
    useAppSelector(selectUsername) || localStorage.getItem("username") || "";
  const token =
    useAppSelector(selectToken) || localStorage.getItem("token") || "";

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchVerifyToken = useCallback(async () => {
    if (!username || !token) {
      if (isMobile) {
        navigate(PATH.Account.login);
      } else {
        navigate("/");
        dispatch(setOpenModal(ModalTypeValue.LOGIN));
      }
      return;
    }

    try {
      setIsLoading(true);
      const { status } = await AuthApi.verifyToken(username, {
        username,
        token,
      });
      if (status === ResponseCode.SUCCESS) {
        return;
      }
      handleResetData(dispatch, navigate);
    } finally {
      setIsLoading(false);
    }
  }, [username]);

  useEffect(() => {
    fetchVerifyToken();
  }, [fetchVerifyToken]);

  return { isLoading };
};
